import React from 'react';
import { HowToStartGuide, Faq, ResourceGuides, Forum } from '../../../shared/Link';
import { HeaderCollapsible } from '../index';

export const SupportCollapsible = () => (
  <HeaderCollapsible title="affiliates_signup_perseus.header.support">
    <HowToStartGuide variant="subitem" />
    <Faq variant="subitem" />
    <Forum variant="subitem" />
    <ResourceGuides variant="subitem" />
  </HeaderCollapsible>
);
